import { createBrowserRouter } from 'react-router-dom';
import { AppLayout } from '@/components/layout/AppLayout';
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { LoginPage } from '@/modules/auth/LoginPage';
import { AchatsPage } from '@/modules/achats/AchatsPage';
import { StockPage } from '@/modules/stock/StockPage';
import { ChequesPage } from '@/modules/cheques/ChequesPage';
import { CorbeillePage } from '@/modules/corbeille/CorbeillePage';
import { SauvegardePage } from '@/modules/sauvegarde/SauvegardePage';
import { AppelsOffresPage } from '@/modules/appels-offres/AppelsOffresPage';
import { ChantierDetailPage } from '@/modules/chantiers/ChantierDetailPage';
import { ChantiersPage } from '@/modules/chantiers/ChantiersPage';
import { ControleCoutsPage } from '@/modules/couts/ControleCoutsPage';
import { ControleCoutsDetailPage } from '@/modules/couts/ControleCoutsDetailPage';
import { ComptabilitePage } from '@/modules/comptabilite/ComptabilitePage';
import { CrmPage } from '@/modules/crm/CrmPage';
import { HsePage } from '@/modules/hse/HsePage';
import { MessageriePage } from '@/modules/messagerie/MessageriePage';
import { TachesPage } from '@/modules/taches/TachesPage';
import { ImmobilisationsPage } from '@/modules/immobilisations/ImmobilisationsPage';
import { LiasseOfficiellePage } from '@/modules/comptabilite/LiasseOfficiellePage';
import { DepensesPage } from '@/modules/depenses/DepensesPage';
import { FacturesPage } from '@/modules/factures/FacturesPage';
import { DevisPage } from '@/modules/devis/DevisPage';
import { EnginsPage } from '@/modules/engins/EnginsPage';
import { EnginDetailPage } from '@/modules/engins/EnginDetailPage';
import { EtatsLocationPage } from '@/modules/engins/EtatsLocationPage';
import { LocationsEnginsPage } from '@/modules/engins/LocationsEnginsPage';
import { FiscalitePage } from '@/modules/fiscalite/FiscalitePage';
import { RhPage } from '@/modules/rh/RhPage';
import { SituationsPage } from '@/modules/situations/SituationsPage';
import { ReferentielDocumentairePage } from '@/modules/soumissions/ReferentielDocumentairePage';
import { SousTraitantsPage } from '@/modules/sous-traitants/SousTraitantsPage';
import { ClientsPage, FournisseursPage } from '@/modules/tiers/TiersPage';
import { TiersDetailPage } from '@/modules/tiers/TiersDetailPage';
import { TresoreriePage } from '@/modules/tresorerie/TresoreriePage';
import { ParametresPage } from '@/modules/parametres/ParametresPage';
import { JournalPage } from '@/modules/journal/JournalPage';
import { DashboardPage } from '@/pages/DashboardPage';
import { NotFoundPage } from '@/pages/NotFoundPage';

/**
 * Définition des routes. /login est publique ; tout le reste est protégé par
 * authentification. Le tableau de bord et les Paramètres sont implémentés ;
 * les autres modules affichent un placeholder jusqu'à leur phase.
 */
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    path: '/',
    element: (
      <ProtectedRoute>
        <AppLayout />
      </ProtectedRoute>
    ),
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'clients', element: <ClientsPage /> },
      { path: 'fournisseurs', element: <FournisseursPage /> },
      { path: 'tiers/:id', element: <TiersDetailPage /> },
      { path: 'appels-offres', element: <AppelsOffresPage /> },
      { path: 'crm', element: <CrmPage /> },
      { path: 'documents-entreprise', element: <ReferentielDocumentairePage /> },
      { path: 'chantiers', element: <ChantiersPage /> },
      { path: 'chantiers/:id', element: <ChantierDetailPage /> },
      { path: 'situations', element: <SituationsPage /> },
      { path: 'depenses', element: <DepensesPage /> },
      { path: 'factures', element: <FacturesPage /> },
      { path: 'devis', element: <DevisPage /> },
      { path: 'couts', element: <ControleCoutsPage /> },
      { path: 'couts/:id', element: <ControleCoutsDetailPage /> },
      { path: 'engins', element: <EnginsPage /> },
      { path: 'engins/etats', element: <EtatsLocationPage /> },
      { path: 'engins/locations', element: <LocationsEnginsPage /> },
      { path: 'engins/:id', element: <EnginDetailPage /> },
      { path: 'rh', element: <RhPage /> },
      { path: 'hse', element: <HsePage /> },
      { path: 'messagerie', element: <MessageriePage /> },
      { path: 'taches', element: <TachesPage /> },
      { path: 'achats', element: <AchatsPage /> },
      { path: 'stock', element: <StockPage /> },
      { path: 'sous-traitants', element: <SousTraitantsPage /> },
      { path: 'comptabilite', element: <ComptabilitePage /> },
      { path: 'immobilisations', element: <ImmobilisationsPage /> },
      { path: 'liasse', element: <LiasseOfficiellePage /> },
      { path: 'fiscalite', element: <FiscalitePage /> },
      { path: 'tresorerie', element: <TresoreriePage /> },
      { path: 'cheques', element: <ChequesPage /> },
      { path: 'parametres', element: <ParametresPage /> },
      { path: 'journal', element: <JournalPage /> },
      { path: 'corbeille', element: <CorbeillePage /> },
      { path: 'sauvegarde', element: <SauvegardePage /> },
      { path: '*', element: <NotFoundPage /> },
    ],
  },
]);
